import BookingDetailSection from './BookingDetailSection';
export default BookingDetailSection;
